import {EventEmitter, Injectable} from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class ClienteHistoricoService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Histório do Cliente por id
     * @param id ID da Histório do Cliente
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "clientes/historico/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "clientes/historico"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Histório do Cliente
     * @param id ID da Histório do Cliente
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "clientes/historico/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Histório do Cliente
     * @param params Json Histório do Cliente
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "clientes/historico", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Histório do Cliente
     * @param params Json Histório do Cliente
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "clientes/historico/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Upload de arquivo
     * @param file 
     */
    upload(file:any):Observable<any>{
        const formData = new FormData();
        formData.append("arquivo", file);
        return this._http.post(this.utilitesService.urlPrefix + "clientes/historico/upload", formData, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Exporta Lista em Excel
     * @param id ID
     */
    getAllExport(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";

        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }
        return this._http.get(this.utilitesService.urlPrefix + "clientes/historico/export" + env, {
            responseType: "arraybuffer",
            headers: new HttpHeaders({                
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "Authorization": "Bearer " + this.authService.getToken(),                
                "Access-Control-Allow-Origin": "*",
            })
        });
    }

}
